import Events from './util/eventEmitter';
import EventsFallback from './lib/events_fallback';
import Analytics from './util/analytics.js';
import Errors from './util/errors.js';
import PropertyTypeMask from './util/masks.js';
import Alert from './views/components/alert.js';
import ViewRegistry from './viewRegistry.js';

export default class ContentRegion extends EventsFallback {
  constructor(...args) {
    super(...args);
    this.alert = new Alert({
      dom: $('.alert-box:not(.persistent)'),
    });
    this.spinner = $('#progress-indicator');

    this._attachEvents();
  }

  start() {
    this.alert.show();
    this.firstLoading = true;
  }

  load(View) {
    ViewRegistry.load(View);

    if (!this.firstLoading) {
      Analytics.trackPage();
    }

    this.firstLoading = false;
  }

  onError(xhr, textStatus) {
    ViewRegistry.error();
    this._showErrorMessage(xhr, textStatus);
    this._restoreDeleteBtnText();
  }

  _attachEvents() {
    var $document = $(document),
      submitFormViaFields = $.proxy(this._submitFormViaFields, this),
      addMultipleField = $.proxy(this._addMultipleField, this),
      removeMultipleField = $.proxy(this._removeMultipleField, this);

    $document.on('keydown', '.multiple-value', submitFormViaFields);
    $document.on('click', '.remove-input', removeMultipleField);
    $document.on('click', '.add-input', addMultipleField);

    // Events
    Events.on('showErrorMessage', this._showErrorMessage.bind(this));
  }

  _submitFormViaFields(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      $(e.currentTarget).closest('form').find('.submit').trigger('click');
    }
  }

  _restoreDeleteBtnText() {
    if (
      ViewRegistry.currentView === null ||
      typeof ViewRegistry.currentView.$el === 'undefined'
    ) {
      return;
    }
    if (ViewRegistry.currentView.$el.find('.pjax-delete').length > 0) {
      ViewRegistry.currentView.$el
        .find('.pjax-delete')
        .html('<i class="icon trash"></i>Delete');
    }
  }

  _showErrorMessage(xhr, textStatus) {
    var alert, message;

    if (textStatus === 'timeout') {
      return;
    }
    message =
      xhr.getResponseHeader('CustomErrorMessage') ||
      ViewRegistry.getError(xhr.status) ||
      Errors.getMessage(xhr.status);

    alert = new Alert({
      message: message,
      type: 'alert',
    });

    alert.prependTo('#main-content').show();

    if (window.pageYOffset > 118) {
      $('html, body').animate(
        {
          scrollTop: alert.$el.offset().top - 10,
        },
        750,
      );
    }

    Analytics.trackEvent(
      'error',
      xhr.status,
      window.location.hostname + window.location.pathname,
    );
  }

  _removeMultipleField(e) {
    var target = e.currentTarget;

    e.preventDefault();
    $(target).closest('div').remove();
  }

  _addMultipleField(e) {
    e.preventDefault();

    var $target = $(e.currentTarget),
      $form = $target.closest('form'),
      $container = $form.find('.' + $target.data('container')),
      $newInput,
      $clonedInput;

    $clonedInput = $target
      .parent()
      .find('.normal-input:first input[type=text]')
      .clone();

    $clonedInput.removeAttr('id').removeAttr('field').removeAttr('value');

    $newInput = $(
      [
        '<div class="normal-input">',
        $clonedInput[0].outerHTML,
        '<button class="ui icon red button multiple-value-button multiple-value-button-remove remove-input" ' +
          'name="remove" title="Remove field">',
        '<i class="minus circle icon"></i>',
        '</button>',
        '</div>',
      ].join('\n'),
    );

    $newInput.insertBefore($target);

    if ($clonedInput.attr('mask') !== undefined) {
      $form
        .find('.normal-input:last input[type=text]')
        .inputmask(
          $.extend(
            {},
            PropertyTypeMask.opts,
            PropertyTypeMask.get($clonedInput.attr('mask')),
          ),
        );
    }

    $newInput.find('input').trigger('focus');

    $container.find('.multiple-value-button').css({
      display: 'block',
    });
  }
}
